/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface NdaFileUrl {
  ndaUrl: string;
}

/**
 * This interface describes how the FeeStatementFileApiResponse is returned by the API,
 * so we can leverage the strict typing capabilities and not rely on "any"
 */
export interface NdaFileUrlApiResponse {
  nda_url: string;
}

/**
 * This method transforms the FeeStatementFileApiResponse into our own
 * FeeStatementFile object which our application understands
 * @param response the fee statement file API response
 * @returns the deserialized FeeStatementFile
 */
export function ndaFileUrlFromApiResponse(response: NdaFileUrlApiResponse): NdaFileUrl {
  return {
    ndaUrl: response.nda_url,
  };
}
